import { twColor } from "@/utils/style";
import Icon from "components/icon";
import { join } from "math";
import { useBreadcrumbs, type Crumb } from "~/composables/useBreadcrumbs";
import { useResponsive } from "~/composables/useResponsive";
import { isSVGIconObject } from "@/types/elements/icon";

const CrumbItem = defineComponent<{
  crumb: Crumb;
  crumbIndex: number;
}>(
  (props) => {
    const router = useRouter();

    const handleClick = () => {
      const path = props.crumb.path;
      if (path && !props.crumb.active && !props.crumb.ghost) {
        router.push(path);
      }
    };

    const name = computed(() => unref(props.crumb.name));
    const isLoading = computed(() => !!unref(props.crumb.loading));

    return () => {
      const testid = `breadcrumb-${String(name.value || '').toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}`;
      return (
        <div
          onClick={handleClick}
          data-testid={testid}
          data-active={props.crumb.active === true}
          class="select-none  items-center gap-2 hover:cursor-pointer data-[active=true]:text-gray-900 hover:text-primary-500 transition-colors"
          style={[
            props.crumb.icon && props.crumbIndex <= 0
              ? {
                  display: "grid",
                  gridTemplateColumns: "max-content max-content",
                  alignItems: "center",
                }
              : {},
          ]}
        >
          {props.crumb.icon && props.crumbIndex <= 0 && (
            <Icon
              size="0.85rem"
              fill={isSVGIconObject(props.crumb.icon) ? (props.crumb.icon.fill || "currentColor") : "currentColor"}
              stroke={isSVGIconObject(props.crumb.icon) ? (props.crumb.icon.stroke || "none") : "none"}
              src={isSVGIconObject(props.crumb.icon) ? props.crumb.icon.src : props.crumb.icon}
            />
          )}
          {isLoading.value ? (
            <div class="grid items-center justify-center">
              <Icon
                src={async () =>
                  import("assets/img/svg/icons/moon-spinner.svg?raw")
                }
                size="0.85rem"
                stroke="none"
                fill={twColor("primary-500")}
                class="animate-spin"
              />
            </div>
          ) : (
            <div class="text-sm font-medium">{name.value}</div>
          )}
        </div>
      );
    };
  },
  { props: ["crumb", "crumbIndex"] },
);

export const AutomaticBreadcrumbs = defineComponent(() => {
  const bread = useBreadcrumbs();

	const { isTablet } = useResponsive();

  return () => {

		const crumbsToShow = isTablet.value ? bread.crumbs.value.filter((crumb) => crumb.active) : bread.crumbs.value;

    return (
      <div class="flex flex-row items-center gap-1 flex-wrap">
        {join(
          crumbsToShow.map((crumb, i) => {
            const name = unref(crumb.name);
            return <CrumbItem crumb={crumb} crumbIndex={i} key={`${crumb.path}-${name}`} />;
          }),
          {
            suffix: () => (
              <div class="grid items-center justify-center">
                <Icon
                  style={{
                    rotate: "180deg",
                  }}
                  fill="currentColor"
                  stroke="none"
                  size="0.75rem"
                  src={async () =>
                    import("assets/img/svg/icons/chevron_left.svg?raw")
                  }
                />
              </div>
            ),
          },
        )}
      </div>
    );
  };
});
